// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductGridDisplay_container__KAmKv","row":"ProductGridDisplay_row__p7d_0","col":"ProductGridDisplay_col__iSbm1"};